import _ from "lodash";

export const fileToJSON = (file) => {
  try {
    const fileName = file.name;
    // Split the file name by " - " to separate each part
    const parts = fileName.split(" - ");
    // Extract each part and map to the corresponding property
    const storeName = parts[0];
    const type = parts[1];
    const id = parts[2];
    const quantity = parseInt(parts[3].split(" ")[0], 10); // Extract the number from "1 adet"
    const isDoubleSided = parts[4].toLowerCase() === "double side";
    let side = "FRONT";
    if (parts.length > 5) {
      side = parts[5].split(".")[0];
    }

    // Return the JSON object
    return {
      storeName,
      type,
      id,
      quantity,
      isDoubleSided,
      side,
      compressedContent: file.compressedContent,
      rawContent: file.rawContent,
    };
  } catch {
    return { error: "Invalid file name" };
  }
};

export const calculateGrid = (
  plateWidth,
  plateHeight,
  productWidth,
  productHeight,
  outMarginX,
  outMarginY,
  gapX,
  gapY
) => {
  const blocks = [];
  let y = outMarginY;
  let x = outMarginX;
  let rowNum = 0;
  let colNum = 0; // We will set this after processing the first row

  while (y + productHeight <= plateHeight - outMarginY / 2) {
    let currentColNum = 0; // Track columns for this row
    while (x + productWidth <= plateWidth - outMarginX / 2) {
      blocks.push({
        x,
        y,
        width: productWidth,
        height: productHeight,
      });

      x += productWidth + gapX;
      currentColNum += 1; // Count columns in this row
    }

    // Set colNum only for the first row (since all rows should have the same column count)
    if (rowNum === 0) {
      colNum = currentColNum;
    }

    y += productHeight + gapY;
    x = outMarginX;
    rowNum += 1;
  }

  return {
    blocks,
    rowNum,
    colNum, // Now colNum correctly reflects the number of columns per row
  };
};

export const getObjectsPerQuantity = (object) => {
  const filesPerQuantity = [];
  for (let i = 0; i < object.length; i++) {
    const { id, quantity } = object[i];
    for (let j = 0; j < quantity; j++) {
      filesPerQuantity.push({ ...object[i], id });
    }
  }
  return filesPerQuantity;
};

export const objectSegementation = (data) => {
  // Transform Data
  const groupedByType = _.groupBy(data, "type");

  const transformed = Object.keys(groupedByType).map((type) => {
    const items = groupedByType[type];

    // Separate double-sided items
    const doubleSidedMap = _.groupBy(
      items.filter((item) => item.isDoubleSided),
      "id"
    );

    const doubleSided = Object.values(doubleSidedMap).map((sides) => {
      const pseudoSides = sides.map((side) => fileToJSON(side));
      return {
        orderId: sides[0].id,
        storeName: sides[0].storeName,
        quantity: sides[0].quantity,
        content: {
          front: pseudoSides.find((s) => s.side === "FRONT"),
          back: pseudoSides.find((s) => s.side === "BACK"),
        },
      };
    });

    // Transform single-sided items
    const singleSided = items
      .filter((item) => !item.isDoubleSided)
      .map((item) => ({
        orderId: item.id,
        storeName: item.storeName,
        quantity: item.quantity,
        content: item.compressedContent,
      }));

    return {
      type,
      batches: {
        doubleSided,
        singleSided,
      },
    };
  });

  return transformed;
};
